import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Input from "@mui/material/Input";
// @mui/icons-material
import Clear from "@mui/icons-material/Clear";
import Check from "@mui/icons-material/Check";
// core components

import styles from "./CustomInput.module.scss";

export default function CustomInput(props) {
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    white,
    inputRootCustomClasses,
    success
  } = props;
  const labelClassName = classNames(styles.labelRoot, {
    [styles.labelRootError]: error,
    [styles.labelRootSuccess]: success && !error,
  });
  const underlineClasses = classNames(styles.underline, {
    [styles.underlineError]: error,
    [styles.underlineSuccess]: success && !error,
    [styles.whiteUnderline]: white,
  });
  const marginTop = classNames({
    [inputRootCustomClasses]: Boolean(inputRootCustomClasses),
  });
  const inputClasses = classNames(styles.input, {
    [styles.whiteInput]: white,
  });
  const formControlClasses = classNames(
    styles.formControl,
    formControlProps?.className
  );
  return (
    <FormControl {...formControlProps} className={formControlClasses}>
      {labelText !== undefined ? (
        <InputLabel
          className={labelClassName}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>
      ) : null}
      <Input
        classes={{
          input: inputClasses,
          root: marginTop,
          disabled: styles.disabled,
          underline: underlineClasses
        }}
        id={id}
        {...inputProps}
      />
      {error ? (
        <Clear className={classNames(styles.feedback, styles.labelRootError)} />
      ) : success ? (
        <Check
          className={classNames(styles.feedback, styles.labelRootSuccess)}
        />
      ) : null}
    </FormControl>
  );
}

CustomInput.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool
};
